<fc-search-input
  [label]="label || 'LOCATION.LABEL' | translate"
  [control]="control"
  [isLocationInput]="true"
  [search]="search"
  [displayWith]="displayWith"
  [showSearchIcon]="showSearchIcon"
  [requiredMark]="requiredMark"
  [preloadOptions]="preloadOptions"
  [searchOnFocus]="searchOnFocus"
  [translateErrorPrefix]="translateErrorPrefix"
></fc-search-input>
